import React, { FC, KeyboardEvent, useCallback } from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import { isDefined } from "@mapmycustomers/shared/util/assert";
import { NumberField } from "@mapmycustomers/ui";

import EditorComponentProps from "./EditorComponentProps";
import styles from "./RelativeDatesEditor.module.scss";

export interface RelativeDatesEditorProps extends EditorComponentProps<number> {}

const RelativeDatesEditor: FC<RelativeDatesEditorProps> = ({
  className,
  duplicate,
  onChange,
  onEnter,
  ...props
}) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (value: number | undefined) => {
      if (isDefined(value)) {
        onChange?.(value);
      }
    },
    [onChange]
  );

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        onEnter?.();
      }
    },
    [onEnter]
  );

  return (
    <div className={cn(styles.container, className)}>
      <NumberField
        className={styles.editor}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        precision={0}
        status={duplicate ? "error" : ""}
        {...props}
      />
      <div>
        {intl.formatMessage({
          id: "map.colorization.createEditSidebar.styleEditor.datingMethod.relative.label",
          defaultMessage: "Days from now",
          description: "Label for picker in Relative Dating method in Pin Legends",
        })}
      </div>
    </div>
  );
};

export default RelativeDatesEditor;
